//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';
import _ from 'underscore';

//style
import './FixedSets.scss';

//api
import { api } from '../../functions/api';

//custom components
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import CustomTable from '../../components/complex/customTable';
import DeleteDialog from '../../components/global/deleteDialog';
import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddEdit from './AddEdit/AddEditFixedSet'
import ChangeItems from './ChangeValues/ChangeValues';

//material-ui
import { CircularProgress } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus, mdiUpload } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class FixedSets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: true,
            siblingsDialog: false,
            addEditDialog: false,
            changeItems: false,
            idFixedSet: 0,
            shop_id: 2
        }
    }

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.FIXED_SETS);
        this.setState({shop_id: Number(this.props.match.params.idShop)})
        this.loadFixedSets();
    }

    componentWillReceiveProps() {
        if(Number(this.props.match.params.idShop) !== this.state.shop_id) {
            this.setState({shop_id: Number(this.props.match.params.idShop), loadingPage: true})
            this.loadFixedSets()
        }
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    tableHeader = [
        {
            "title": "title",
            "numeric": false
        },
        // {
        //     "title": "link_bekoshop",
        //     "numeric": false,
        // },
        {
            "title": "list_products",
            "numeric": true,
        },
        {
            "title": "client_price",
            "numeric": true
        },
        {
            "title": "discount",
            "numeric": true
        },
        // {
        //     "title": "action_items",
        //     "numeric": false,
        //     textAlign: "center"
        // },
        {
            "title": "production",
            "numeric": false,
            textAlign: "center"
        },
        {
            "title": "position",
            "numeric":false,
            textAlign: "center"
        }
    ];
    tableBody = [
        "name",
        // "link",
        "products_count",
        "total",
        "discount",
        // "action_items",
        "production",
        "id"
    ]

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES['FIXED-SETS'].LINK_BEKOSHOP,
            action: "fixed-sets",
        },
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            action: "edit"
        },
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
            action: "delete"
        }
    ];

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.tableReload = true;
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadFixedSets()
    }

    loadFixedSets = _.debounce(async (size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {
        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
                this.setState({searchTerm: searchterm})
            }
        }

        let filters = {}
        let params = {}

        let shop_id = Number(this.props.match.params.idShop)
        filters.shop_id = shop_id
        params.filters = filters
        params.searchterm = searchterm

        

        let load_data = await api({
            method:'get',
            url: 'products/static-sets',
            // TODO: vymazat ked bude na testovacom serveri
            // postman: true,
            authorization: this.props.internal.user.access_token,
            params: params
            // {
            //     searchterm: searchterm,
            //     page:{
            //         number:page,
            //         size:size,
            //     },
            //     order: [
            //         {
            //             by: by,
            //             dir: dir
            //         }
            //     ]
            // }
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({loadingTable: false})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
    }, 500)

    openCloseDialogChangePosition = (refresh = false) => {
        this.setState({siblingsDialog: !this.state.siblingsDialog})
        if(refresh) {
            this.loadFixedSets()
        }
    }

    handleOpenCloseDialog = (refresh = false) => {
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(refresh) {
            this.loadFixedSets()
        }
    }

    clickOnProductionStatus = async(id, status) => {
        let update_data = await api({
            method: 'patch',
            url: `products/static-sets/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                production: status
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.loadFixedSets()
        }
    }

    handleDelete = async() => {
        let idFixedSet = toJS(this.props.internal.actionDeleteObj.id)

        //TODO: vymazat ked bude na testovacom serveri
        // idFixedSet = 2

        let delete_data = await api({
            method: "delete",

            //TODO: vymazat ked bude na testovacom serveri
            // postman: true,
            
            url: `products/static-sets/${idFixedSet}`,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadFixedSets();
            this.props.internal.setActionDelete();
        }
    }

    changeItems = (idFixedSet) => {
        this.setState({changeItems: !this.state.changeItems, idFixedSet: idFixedSet})
    }

    render () {
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'fixed-sets'}>
                    {/* dialog pre upravovanie/vytvorenie */}
                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEdit
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES['FIXED-SETS'].CREATE_NEW_FIXED_SET_TITLE :this.props.translate.i18n.MODULES['FIXED-SETS'].EDIT_FIXED_SET_TITLE}
                            shop_id={this.state.shop_id}
                        />
                    }
                    {/* zmena poradia prvkov */}
                    <ChangeSiblingsPositions
                        open={this.state.siblingsDialog}
                        onClose={this.openCloseDialogChangePosition}
                        title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                        childs={this.props.internal.dataForTable.data}
                    />
                    
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES['FIXED-SETS'].DELETE_FIXED_SET_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {this.state.changeItems &&
                        <ChangeItems
                            open={this.state.changeItems}
                            onClose={this.changeItems}
                            title={this.props.translate.i18n.MODULES['FIXED-SETS'].EDIT_ITEMS_TITLE}
                            id={this.state.idFixedSet}
                        />
                    }
                    <div className={'flex space-between mb-first-line'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.MODULES['FIXED-SETS'].ADD_NEW_FIXED_SET}
                            onClick = {this.handleOpenCloseDialog}
                        >
                            <Icon path = {mdiPlus} size = {1}/>
                        </CustomButton>
                    </div>
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        // null
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/fixed-sets'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openCloseDialogChangePosition}
                            clickOnProductionStatus={this.clickOnProductionStatus}
                            // handleChangeType={this.handleChangeType}
                            disablePagination={true}
                            disableSort
                            changeItems={this.changeItems}
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/fixedSets/FixedSets.jsx